import { render, staticRenderFns } from "./trainingstatistics.vue?vue&type=template&id=0ae74171"
import script from "./trainingstatistics.vue?vue&type=script&lang=js"
export * from "./trainingstatistics.vue?vue&type=script&lang=js"
import style0 from "./trainingstatistics.vue?vue&type=style&index=0&id=0ae74171&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports